








import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

type BaseMapperData = {
	ID: number;
	ZAZNAM_ID: number;
	X_VYROBEKVOZ_OZN: string;
	IBS_KOD: string;
	TEXT: string;
	X_P: string;
};

type RequestedData = {
	isClear: boolean;
	value: number | null;
	text: string | null;
	zaznamId: number | null;
	ibsKod: string | null;
	vyrobekVozOzn: string | null;
	xP: string | null;
};

type Data = {
	storeObject: string;
	emptyObject: RequestedData;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'IBS_KOD' },
		showLabel: { type: Boolean, default: true },
		ibskod: { type: String },
		text: { type: String },
	},
	data(): Data {
		return {
			storeObject: NAME,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				ibsKod: null,
				zaznamId: null,
				vyrobekVozOzn: null,
				xP: null,
			},
		};
	},
	computed: {
		ibskodCmp: {
			get() {
				return this.ibskod;
			},
			set(val) {
				this.$emit('update:ibskod', val);
			},
		},
	},
	methods: {
		dbToBaseMapper(data: BaseMapperData): RequestedData {
			return {
				value: data.ID,
				text: data.TEXT,
				zaznamId: data.ZAZNAM_ID,
				vyrobekVozOzn: data.X_VYROBEKVOZ_OZN,
				ibsKod: data.IBS_KOD,
				isClear: false,
				xP: data.X_P,
			};
		},
	},
});
